;(function () {
  angular
    .module('contrast.sso')
    .controller(
      'SSOEditCtrl',
      function (
        $scope,
        $routeSegment,
        $rootScope,
        $location,
        $translate,
        $http,
        $routeParams,
        logger,
        dialogs,
        ErrorService,
        SAMLService,
        UserService,
        AuthConfigService,
        sharedGroupService,
        groupsApiConfig,
        RoleFactory,
        FeaturesService,
        SSOFactory,
        AUTH_MODE,
        permissions
      ) {
        'ngInject'

        var translGlobal = {
          title_idpMetadataCertificateUploadButton: $translate.instant(
            'title_singleSignOnSettings_idpMetadataCertificateUploadButton'
          ),
          title_idpMetadataNone: $translate.instant(
            'title_singleSignOnSettings_idpMetadataNone'
          ),
          title_singleSignOnSettings_successfullyConnected: $translate.instant(
            'title_singleSignOnSettings_successfullyConnected'
          ),
          title_singleSignOnSettings_successfullyUpdated: $translate.instant(
            'title_singleSignOnSettings_successfullyUpdated'
          )
        }

        var vm = this,
          hasConfig = false,
          testError = null

        function init() {
          getSPMetadata()
          getAllConfig()

          vm.form = $scope.form
        }

        angular.extend(vm, {
          model: {
            loading: false
          },
          select: {
            roles: [],
            groups: []
          },
          spMetadata: {},
          settings: {
            provisioning_enabled: false,
            auto_add_to_group_enabled: false,
            auto_remove_from_group_enabled: false,
            domains: [{ value: '' }]
          },
          isSecretNode: false,
          hasMetadataUrl: true,
          providerKeyFile: null,
          providerKeyFilename: '',
          errorsMessages: {},
          isEOP: false,
          editing: false,
          canceling: false,
          hasTestError: false,
          uploadLabel: translGlobal.title_idpMetadataCertificateUploadButton,
          noUploadAttachment: translGlobal.title_idpMetadataNone
        })

        angular.extend(vm, {
          verifyEnableAutoRemove: verifyEnableAutoRemove,
          formInvalid: formInvalid,
          showDebugLog: showDebugLog,
          downloadTestError: downloadTestError,
          save: save,
          clearProviderKeyFile: clearProviderKeyFile,
          edit: edit,
          cancel: cancel,
          cancelCreation: cancelCreation,
          addDomain: addDomain,
          deleteDomain: deleteDomain,
          domainsInvalid: domainsInvalid,
          rbacSSOEnabled: rbacSSOEnabled
        })

        function rbacSSOEnabled() {
          const rbacStatus = FeaturesService.getRbacStatus()
          return (
            rbacStatus.enabled &&
            rbacStatus.isRbacSSOProvisioningEnabled &&
            permissions.hasRbacManagePermission('ROLE', 'PLATFORM_ORG_MANAGE')
          )
        }

        function verifyEnableAutoRemove($event) {
          var transl = {
            title: $translate.instant(
              'detail_singleSignOnSettings_autoRemoveFromGroup_checkbox'
            ),
            message: $translate.instant(
              'detail_singleSignOnSettings_enable_auto_remove_warning'
            ),
            action_confirm: $translate.instant('action_confirm'),
            action_cancel: $translate.instant('action_cancel')
          }

          if (vm.settings.auto_remove_from_group_enabled) {
            vm.settings.auto_remove_from_group_enabled = false
          } else {
            $event.preventDefault()
            dialogs
              .confirm(transl.title, transl.message, {
                size: 'md-sm',
                yes: transl.action_confirm,
                no: transl.action_cancel
              })
              .result.then(function () {
                vm.settings.auto_remove_from_group_enabled = true
              })
          }
        }

        function addDomain() {
          vm.settings.domains.push({ value: '' })
        }

        function deleteDomain(domain) {
          var idx = vm.settings.domains.indexOf(domain)
          if (idx > -1) {
            vm.settings.domains.splice(idx, 1)
          }
        }

        const DEFAULT_RBAC_USER_ACCESS_GROUP = 'Organization View'

        function getAllConfig() {
          return RoleFactory.getRoles()
            .then(function (response) {
              vm.select.roles = response.data.groups
              vm.settings.role = vm.select.roles[0]
            })
            .then(function () {
              return groupsApiConfig.getGroupsBase()
            })
            .then(function (response) {
              vm.select.groups = response.data.groups
              sharedGroupService.formatOrganizationGroups(vm.select.groups)
              vm.settings.group = vm.select.groups[0]
            })
            .then(function () {
              return getSAMLConfig()
            })
            .then(function () {
              if (rbacSSOEnabled()) {
                getUserAccessGroups($routeParams.orgUuid).then(function (
                  groups
                ) {
                  vm.select.uags = groups

                  if (vm.settings.default_rbac_user_access_group_id) {
                    vm.settings.uag = groups.find(
                      ({ id }) =>
                        id === vm.settings.default_rbac_user_access_group_id
                    )
                  }

                  if (!vm.settings.uag) {
                    vm.settings.uag = groups.find(
                      ({ name }) => name === DEFAULT_RBAC_USER_ACCESS_GROUP
                    )
                  }
                })
              }
            })
        }

        function getUserAccessGroups(orgUuid) {
          const pageSize = 25
          let page = 0
          let allGroups = []

          function fetchGroups() {
            return $http
              .get(
                `/api/v4/organizations/${orgUuid}/user-access-groups?page=${page}&size=${pageSize}&sort=isSystem,asc&sort=name,asc`
              )
              .then((response) => {
                const groups = response.data.content
                allGroups = allGroups.concat(groups)

                // Check if there are more groups to fetch
                if (groups.length === pageSize) {
                  page++
                  return fetchGroups() // Recursively fetch the next page
                } else {
                  return allGroups // Resolve with all groups when no more groups are found
                }
              })
              .catch(function (err) {
                ErrorService.processError(err)
                return {
                  groups: []
                }
              })
          }

          return fetchGroups()
        }

        function getSPMetadata() {
          return SAMLService.getSPMetadata().then(function (data) {
            vm.spMetadata = data
          })
        }

        function getSAMLConfig() {
          return SSOFactory.getSAMLConfig()
            .then(function (response) {
              if (response.data) {
                if ($routeSegment.startsWith('settings.sso_add')) {
                  $location.path(UserService.buildUrl('/settings/sso'))
                }
                vm.settings = response.data.config
                formatDomains()
                hasConfig = true

                if (!vm.settings.metadata_url) {
                  vm.hasMetadataUrl = false
                }

                vm.settings.role = _.find(vm.select.roles, {
                  group_id: response.data.config.role.group_id
                })
                vm.settings.group = _.find(vm.select.groups, {
                  group_id: response.data.config.access_group.group_id
                })
              }
            })
            .catch(function () {
              return {}
            })
        }

        function formatDomains() {
          var domains = []
          _.each(vm.settings.domains, function (domain) {
            domains.push({ value: domain })
          })
          vm.settings.domains = domains
        }

        function domainsInvalid() {
          return (
            !vm.settings.domains ||
            !vm.settings.domains[0] ||
            !vm.settings.domains[0].value ||
            0 === vm.settings.domains[0].value.length
          )
        }

        function formInvalid() {
          if (
            !vm.settings.group ||
            !vm.settings.role ||
            (vm.settings.provisioning_enabled && domainsInvalid())
          ) {
            return true
          }

          if (!vm.form.idpName.$invalid) {
            if (
              (vm.hasMetadataUrl && !vm.form.metadataUrl.$invalid) ||
              (!vm.hasMetadataUrl && !vm.form.metadataXml.$invalid)
            ) {
              return false
            }
          }
          return true
        }

        function showDebugLog() {
          return vm.hasTestError && !vm.form.metadataUrl.$dirty
        }

        function downloadTestError() {
          if (testError) {
            vm.hasTestError = false
            AuthConfigService.downloadSAMLTestError(
              testError,
              'saml-connection-error.txt'
            )
          }
        }

        $scope.$watch(
          function () {
            return vm.settings.provider_key
          },
          function (newVal, oldVal) {
            if (newVal !== oldVal) {
              vm.form.metadataUrl.$setDirty()
              vm.form.metadataXml.$setDirty()
            }
          }
        )

        function clearProviderKeyFile() {
          vm.form.$setDirty()
          vm.uploadLabel = translGlobal.title_idpMetadataCertificateUploadButton
          vm.settings.provider_key = null
          vm.form.metadataUrl.$setDirty()
          vm.form.metadataXml.$setDirty()
        }

        function save() {
          vm.settings.default_rbac_user_access_group_id = vm.settings.uag
            ? vm.settings.uag.id
            : null
          var savePromise = null,
            config = SAMLService.transformConfig(vm.hasMetadataUrl, vm.settings)
          if (hasConfig) {
            savePromise = SSOFactory.editSAMLConfig(config)
          } else {
            savePromise = SSOFactory.addSAMLConfig(config)
          }

          return savePromise.then(
            function () {
              if ($routeSegment.startsWith('settings.sso_add')) {
                logger.logSuccess(
                  translGlobal.title_singleSignOnSettings_successfullyConnected
                )
                $rootScope.$broadcast(
                  'authentication.mode.change',
                  AUTH_MODE.mode.SAML
                )
                $location.path(UserService.buildUrl('/settings/sso'))
              } else {
                logger.logSuccess(
                  translGlobal.title_singleSignOnSettings_successfullyUpdated
                )
                vm.editing = false
              }
            },
            function (response) {
              vm.hasTestError = true
              testError = response.data.messages
              vm.form.metadataUrl.$setPristine()
              vm.form.metadataXml.$setPristine()
              ErrorService.processError(response)
              ErrorService.bindFieldErrors(
                response.data.errors,
                vm.form,
                vm.errorsMessages
              )
            }
          )
        }

        function edit() {
          vm.editing = true
          vm.form.metadataUrl.$setPristine()
          vm.form.metadataXml.$setPristine()
        }

        function cancel() {
          vm.canceling = true
          getAllConfig().then(function () {
            if (!vm.settings.metadata_url) {
              vm.hasMetadataUrl = false
            } else {
              vm.hasMetadataUrl = true
            }
            vm.hasTestError = false

            vm.form.metadataUrl.$setPristine()
            vm.form.metadataXml.$setPristine()

            vm.canceling = false
            vm.editing = false
          })
        }

        function cancelCreation() {
          $location.path(UserService.buildUrl('/settings/sso'), true)
        }

        init()
      }
    )
})()
